/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_GET_URL, API_GET_PUBLIC, API_POST, API_URL, API_LOGIN, API_GET_GEO_PUBLIC, API_SERVER, API_SCT } from '../../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import * as htmlToImage from 'html-to-image';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import { GoogleMap, LoadScript, Polyline } from '@react-google-maps/api';
import { MAP_STYLE_SILVER, MAP_STYLE_RETRO, MAP_STYLE_DARK, MAP_STYLE_NIGHT, MAP_STYLE_AUBERGINE, MAP_STYLE_BLACK_WHITE, MAP_STYLE_PAPER, MAP_STYLE_GOLDEN, MAP_STYLE_NETWORK } from "../../../../../data/map_style";
import TextTransition, { presets } from "react-text-transition";
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../../../assets/img/overlay_bg_form.png'

import Regulasi from '../../../../../assets/img/simpr_bprb/regulasi.png'
import Persyaratan from '../../../../../assets/img/simpr_bprb/persyaratan.png'
import Pengaduan from '../../../../../assets/img/simpr_bprb/pengaduan.png'
import Pelayanan from '../../../../../assets/img/simpr_bprb/pelayanan.png'
import Data from '../../../../../assets/img/simpr_bprb/data.png'

import Beranda from '../../../../../assets/img/simpr/home/1.png'
import TataRuang from '../../../../../assets/img/simpr/home/2.png'
import Panduan from '../../../../../assets/img/simpr/home/3.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Home';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'peta';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [username, set_username] = useState('');
    const [password, set_password] = useState('');
    const [version, set_version] = useState('')
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [map_style, set_map_style] = useState([])
    const [map_type, set_map_type] = useState('roadmap')
    const [map_sebaran, set_map_sebaran] = useState(null)
    const [map_kabupaten, set_map_kabupaten] = useState(null)
    const [map_provinsi, set_map_provinsi] = useState(null)
    const [map_negara, set_map_negara] = useState(null)

    const [data_save, set_data_save] = useState(null)
    const [data_sebaran, set_data_sebaran] = useState(null)
    const [data_kabupaten, set_data_kabupaten] = useState(null)
    const [data_provinsi, set_data_provinsi] = useState(null)
    const [data_negara, set_data_negara] = useState(null)

    const [center_lat, set_center_lat] = useState(null)
    const [center_lng, set_center_lng] = useState(null)

    const [coords_lat, set_coords_lat] = useState(null)
    const [coords_lng, set_coords_lng] = useState(null)
    const [type, set_type] = useState(null)
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read_negara = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_negara`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data_negara(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_provinsi = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_provinsi`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data_provinsi(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_kabupaten = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_kabupaten`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data_kabupaten(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_sebaran = (pages, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`simpr/bprb/peta/get/public__________?action=read_${request_params}_sebaran`
            // + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data_sebaran(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_negara_map = (urlParams, typeParams) => {

        if(typeParams === 'geojson'){
            if(loading === true){
                return
            }

            loading(true);

            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('------', response.data)
                set_map_negara(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })
        }else if(typeParams === 'kmz'){

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_map_negara(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else{
            error('file type denied')
        }

	}

    const _read_provinsi_map = (urlParams, typeParams) => {

        if(typeParams === 'geojson'){
            if(loading === true){
                return
            }

            loading(true);

            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('------', response.data)
                set_map_provinsi(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })
        }else if(typeParams === 'kmz'){

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_map_provinsi(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else{
            error('file type denied')
        }

	}

    const _read_kabupaten_map = (urlParams, typeParams) => {

        console_dev('type params', typeParams)

        if(typeParams === 'geojson'){

            if(loading === true){
                return
            }

            loading(true);

            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('------', response.data)
                set_map_kabupaten(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else if(typeParams === 'kmz'){

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_map_kabupaten(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else{
            error('file type denied')
        }

	}

    const _read_sebaran_map = (urlParams, typeParams) => {

        if(typeParams === 'geojson'){

            if(loading === true){
                return
            }
    
            loading(true);
    
            API_GET_URL(urlParams)
            .then((response) => {
                console_dev('------', response.data)
                set_map_sebaran(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else if(typeParams === 'kmz'){

            API_GET_GEO_PUBLIC(`geo/get__________?action=kmztogeojson`
                + '&url=' + urlParams
            , 
            ).then((response) => {
                console_dev(`response ${request_params} kmz `, response)
                set_map_sebaran(response.data)
                set_refresh(random_character(16))
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }else{
            error('file type denied')
        }


	}

    const _read_version = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_GET_PUBLIC('version/public__________?key=' + random_character(32)
			+ '&slug=web'
        , 
		).then((response) => {
            console.log('version', JSON.stringify(response.data, undefined, 2))
            if(response.data.result == 'success'){
                set_version(response.data.data[0].version)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _login = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_LOGIN('simpr/bprb/login__________', {
			username: username,
			password: password
		})
        .then((response) => {
			if(response.data.result === 'success'){
                reactLocalStorage.set('@token', response.data.data);
                reactLocalStorage.set('@user', JSON.stringify(response.data.user));
                // set_user(JSON.stringify(response.data.user))
                window.location.reload();
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};

    const _export_png = () => {

        htmlToImage.toPng(document.getElementById('export'))
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'export.png';
            link.href = dataUrl;
            link.click();
        });

    }

    const _export_svg = () => {
        
        function filter (node) {
            return (node.tagName !== 'i');
        }
          
        htmlToImage.toSvg(document.getElementById('export'), { filter: filter })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'export.svg';
            link.href = dataUrl;
            link.click();
        });

        
    }

    const _export_jpg = () => {
        
        htmlToImage.toJpeg(document.getElementById('export'), { quality: 0.95 })
        .then(function (dataUrl) {
            console.log('export : ', dataUrl)
            var link = document.createElement('a');
            link.download = 'export.jpeg';
            link.href = dataUrl;
            link.click();
        });

    }

    // const _geojson_extract = (country, layer) => {
    //     // console_dev('geojson extract country', country)
    //     // console_dev('geojson extract layer', layer)
    //     if(country.properties.NAMOBJ === 'Kawasan Permukiman Perkotaan'){
    //         layer.setStyle({
    //             weight: 2,
    //             opacity: 1,
    //             color: '#8B5590',
    //             fillOpacity: 1,
    //             fillColor: '#8B5590'
    //         }) 
    //     }else if(country.properties.NAMOBJ === 'Kawasan Perkebunan'){
    //         layer.setStyle({
    //             weight: 2,
    //             opacity: 1,
    //             color: '#E19544',
    //             fillOpacity: 1,
    //             fillColor: '#E19544'
    //         }) 
    //     }else if(country.properties.NAMOBJ === 'Kawasan Permukiman Perdesaan'){
    //         layer.setStyle({
    //             weight: 2,
    //             opacity: 1,
    //             color: '#CA5255',
    //             fillOpacity: 1,
    //             fillColor: '#CA5255'
    //         }) 
    //     }else if(country.properties.NAMOBJ === 'Kawasan Tanaman Pangan'){
    //         layer.setStyle({
    //             weight: 2,
    //             opacity: 1,
    //             color: '#9BBE52',
    //             fillOpacity: 1,
    //             fillColor: '#9BBE52'
    //         }) 
    //     }else if(country.properties.NAMOBJ === 'Kawasan Hortikultura'){
    //         layer.setStyle({
    //             weight: 2,
    //             opacity: 1,
    //             color: '#2F9EC6',
    //             fillOpacity: 1,
    //             fillColor: '#2F9EC6'
    //         }) 
    //     }
        
    //     layer.on('click', function (e) {
    //         console_dev('KUPZ', country.properties.KUPZ)
    //         console_dev('B', country.properties.B)
    //         console_dev('Bersyarat', country.properties.Bersyarat)
    //         console_dev('CAGBUD', country.properties.CAGBUD)
    //         console_dev('Diperboleh', country.properties.Diperboleh)
    //         console_dev('I', country.properties.I)
    //         console_dev('JNSRPR', country.properties.JNSRPR)
    //         console_dev('KKOP_1', country.properties.KKOP_1)
    //         console_dev('KODKWS', country.properties.KODKWS)
    //         console_dev('KP2B_2', country.properties.KP2B_2)
    //         console_dev('KRB_03', country.properties.KRB_03)
    //         console_dev('KT_KHUSUS', country.properties.KT_KHUSUS)
    //         console_dev('KUPZ', country.properties.KUPZ)
    //         console_dev('LUASHA', country.properties.LUASHA)
    //         console_dev('NAMOBJ', country.properties.NAMOBJ)
    //         console_dev('OBJECTID', country.properties.OBJECTID)
    //         console_dev('ORDE01', country.properties.ORDE01)
    //         console_dev('ORDE02', country.properties.ORDE02)
    //         console_dev('ORDE03', country.properties.ORDE03)
    //         console_dev('ORDE04', country.properties.ORDE04)
    //         console_dev('RESAIR', country.properties.RESAIR)
    //         console_dev('Shape_Area', country.properties.Shape_Area)
    //         console_dev('Shape_Leng', country.properties.Shape_Leng)
    //         console_dev('Tidak_Dipe', country.properties.Tidak_Dipe)
    //         console_dev('WADMKC', country.properties.WADMKC)
    //         console_dev('WADMKK', country.properties.WADMKK)
    //         console_dev('WADMPR', country.properties.WADMPR)

    //         // set_element('map_detail')
    //     })
    // }
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket(STORAGE_USER[0])
                _read_negara(1, storage_bamboo)
                _read_provinsi(1, storage_bamboo)
                _read_kabupaten(1, storage_bamboo)
                _read_sebaran(1, storage_bamboo)
            }

        }else{
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Text Animation]
    ----------------------------------------------------------------*/
    const [index, setIndex] = React.useState(0);

    React.useEffect(() => {
        const intervalId = setInterval(() =>
        setIndex(index => index + 1),
        3000 // every 3 seconds
        );
        return () => clearTimeout(intervalId);
    }, []);

    const TEXTS = [
        "Live",
        "Login",
        "Official"
    ];
    /*--------------------------------------------------------------
    [End Text Animation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read_negara()
            _read_provinsi()
            _read_kabupaten()
            _read_sebaran()
            _read_version()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])

    useEffect(() => {

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                console.log('position lat ------------ : ', position.coords.latitude)
                console.log('position lng ------------ : ', position.coords.longitude)
                set_coords_lat(position.coords.latitude)
                set_coords_lng(position.coords.longitude)
            });
        }

    }, [])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    const mapRef = useRef(null);
    const [position, setPosition] = useState({
        lat: 3.5340480748983203,
        lng: 99.12247412693083
    });

    function handleLoad(map) {
        mapRef.current = map;
    }

    function handleCenter() {
        if (!mapRef.current) return;

        const newPos = mapRef.current.getCenter().toJSON();
        setPosition(newPos);
    }

    const containerStyle = {
        height: '100vh',
        with: '100%',
        overflow: 'hidden'
    };
      
    const center = {
        lat: 3.5340480748983203,
        lng: 99.12247412693083
    };

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            <div dangerouslySetInnerHTML={{__html: `
            <style>
            .leaflet-control-container { position: absolute; right: 56px } 
            </style>
            `}}></div>

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`delete_${request_params}`)
                                                // _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Test
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        // onChange={e => set_test(e.target.value)}
                                                        // value={test}
                                                    />
                                                </div>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`update_${request_params}`)
                                                // if(file === null){
                                                //     _uploads(`update_text_${request_params}`)
                                                // }else{
                                                //     _uploads(`update_file_${request_params}`)
                                                // }
                                            }} className="_btn _cursor_pointer">
                                                Simpan
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}

            <div style={{position: 'relative'}}>
                <div className="_simpr_home_map_nav">
                    <NavLink 
                        to='/simpr/home' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Beranda
                        </div>    
                        <ion-icon name="home-outline"></ion-icon>
                    </NavLink>
                    <div onClick={() => {
                        if(element === 'map_color'){
                            set_element(null)
                        }else{
                            set_element('map_color')
                            set_map_negara(null)
                            set_map_provinsi(null)
                            set_map_kabupaten(null)
                            set_map_sebaran(null)
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_color' ? '#eee' : null}}>
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Map/Color
                        </div>  
                        <ion-icon name="color-fill-outline"></ion-icon>
                        {
                            element === 'map_color' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        <div onClick={() => {set_map_style('MAP_STYLE_BASIC')}} className="_item">Basic</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_SILVER')}} className="_item">Silver</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_RETRO')}} className="_item">Retro</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_DARK')}} className="_item">Dark</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_NIGHT')}} className="_item">Night</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_AUBERGINE')}} className="_item">Aubergine</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_BLACK_WHITE')}} className="_item">Black White</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_PAPER')}} className="_item">Paper</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_GOLDEN')}} className="_item">Golden</div>
                                        <div onClick={() => {set_map_style('MAP_STYLE_NETWORK')}} className="_item">Network</div>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    <div onClick={() => {
                        if(element === 'map_type'){
                            set_element(null)
                        }else{
                            set_element('map_type')
                            set_map_negara(null)
                            set_map_provinsi(null)
                            set_map_kabupaten(null)
                            set_map_sebaran(null)
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_type' ? '#eee' : null}}>
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Map/Style
                        </div>  
                        <ion-icon name="map-outline"></ion-icon>
                        {
                            element === 'map_type' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        <div onClick={() => {set_map_type('roadmap')}} className="_item">Roadmap</div>
                                        <div onClick={() => {set_map_type('satellite')}} className="_item">Satellite</div>
                                        <div onClick={() => {set_map_type('hybrid')}} className="_item">Hybrid</div>
                                        <div onClick={() => {set_map_type('terrain')}} className="_item">Terrain</div>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    <div onClick={() => {
                        if(element === 'map_category'){
                            set_element(null)
                        }else{
                            set_element('map_category')
                            set_sub_element(null)
                        }

                        if(sub_element === 'map_category_negara'){
                            set_sub_element(null)
                            set_element(null)
                            set_map_provinsi(null)
                            set_map_kabupaten(null)
                            set_map_sebaran(null)
                        }else if(sub_element === 'map_category_provinsi'){
                            set_sub_element(null)
                            set_element(null)
                            set_map_negara(null)
                            set_map_kabupaten(null)
                            set_map_sebaran(null)
                        }else if(sub_element === 'map_category_kabupaten'){
                            set_sub_element(null)
                            set_element(null)
                            set_map_provinsi(null)
                            set_map_negara(null)
                            set_map_sebaran(null)
                        }else if(sub_element === 'map_category_sebaran'){
                            set_sub_element(null)
                            set_element(null)
                            set_map_provinsi(null)
                            set_map_kabupaten(null)
                            set_map_provinsi(null)
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_category' ? '#eee' : null}}>
                        <ion-icon name="location-outline"></ion-icon>
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Maps
                        </div>  
                        {
                            element === 'map_category' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        <div onClick={() => {set_sub_element('map_category_negara')}} className="_item">Negara</div>
                                        <div onClick={() => {set_sub_element('map_category_provinsi')}} className="_item">Provinsi</div>
                                        <div onClick={() => {set_sub_element('map_category_kabupaten')}} className="_item">Kabupaten/Kota</div>
                                        <div onClick={() => {set_sub_element('map_category_sebaran')}} className="_item">Sebaran</div>
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_negara' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_negara && data_negara.list.length > 0 ?
                                                data_negara.list.map((item, index) => (
                                                    <div key={index} onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_negara_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_negara &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_provinsi' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_provinsi && data_provinsi.list.length > 0 ?
                                                data_provinsi.list.map((item, index) => (
                                                    <div key={index} onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_provinsi_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_provinsi &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_kabupaten' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_kabupaten && data_kabupaten.list.length > 0 ?
                                                data_kabupaten.list.map((item, index) => (
                                                    <div key={index} onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_kabupaten_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_provinsi &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                        {
                            sub_element === 'map_category_sebaran' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16}}>
                                        {
                                            data_sebaran && data_sebaran.list.length > 0 ?
                                                data_sebaran.list.map((item, index) => (
                                                    <div key={index} onClick={() => {
                                                        set_center_lat(item.center_lat)
                                                        set_center_lng(item.center_lng)
                                                        set_type(item.type)
                                                        _read_sebaran_map(API_SERVER + '/' + item.path + '/' + item.file, item.type)
                                                    }} className="_item">{decode(item.judul)}</div>
                                                ))
                                            :
                                                data_sebaran &&
                                                <div className="_item">Belum Ada Data</div>
                                        }
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    <div onClick={() => {
                        if(element === 'map_print'){
                            set_element(null)
                        }else{
                            if(map_negara || map_provinsi || map_kabupaten || map_sebaran){
                                set_element('map_print')
                            }else{
                                error('Hanya bisa digunakan ketika sedang berapa pada menu peta geojson')
                            }
                        }
                    }} className="_simpr_home_map_nav_item" style={{backgroundColor: element === 'map_print' ? '#eee' : null}}>
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Export
                        </div>  
                        <ion-icon name="print-outline"></ion-icon>
                        {
                            element === 'map_print' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left" style={{left: '130%', top: 0, borderRadius: 16, padding: 16}}>
                                        <div>
                                            <div onClick={() => {_export_png()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                PNG
                                            </div>
                                            <div onClick={() => {_export_jpg()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                JPG
                                            </div>
                                            <div onClick={() => {_export_svg()}} className="_btn _cursor_pointer _push_r_s" style={{paddingTop: 4, paddingBottom: 4, paddingLeft: 14, paddingRight: 14}}>
                                                SVG
                                            </div>
                                        </div>
                                        <br/>
                                        <p>Tekan <span className="_badge_green">ctrl</span> + p untuk memunculkan fitur print browser</p>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                    <NavLink 
                        to='/simpr/bprb/menu' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            Menu
                        </div>    
                        <ion-icon name="apps-outline"></ion-icon>
                    </NavLink>
                    <NavLink 
                        to='/simpr/bprb/login' 
                        className="_simpr_home_map_nav_item"
                    >
                        <div className="_simpr_home_map_nav_item_tooltip">
                            {
                                STORAGE_USER && STORAGE_USER[0].e_account === 'e_simpr_bprb' ?
                                    'Dashboard'
                                :
                                    'Login/Register'
                            }
                            
                        </div>    
                        <ion-icon name="finger-print-outline"></ion-icon>
                    </NavLink>
                </div>
                
                <div style={{position: 'relative', zIndex: 0, backgroundColor: '#fff'}}>
                    <div id="export">
                        {
                            map_negara ?
                                <MapContainer key={refresh} center={[center_lat, center_lng]} zoom={5} scrollWheelZoom={true} style={{height: '100vh'}}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <GeoJSON key={refresh} data={map_negara} />
                                    {/* <Marker position={[center_lat, center_lng]}>
                                        <Popup>
                                            {data}
                                        </Popup>
                                    </Marker> */}
                                </MapContainer>
                            : map_provinsi ?
                                <MapContainer key={refresh} center={[center_lat, center_lng]} zoom={8} scrollWheelZoom={true} style={{height: '100vh'}}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <GeoJSON key={refresh} data={map_provinsi} />
                                    {/* <Marker position={[center_lat, center_lng]}>
                                        <Popup>
                                            {data}
                                        </Popup>
                                    </Marker> */}
                                </MapContainer>
                            : map_kabupaten ?
                                <MapContainer key={refresh} center={[center_lat, center_lng]} zoom={12} scrollWheelZoom={true} style={{height: '100vh'}}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <GeoJSON key={refresh} data={map_kabupaten} />
                                    {/* <Marker position={[center_lat, center_lng]}>
                                        <Popup>
                                            {data}
                                        </Popup>
                                    </Marker> */}
                                </MapContainer>
                            : map_sebaran ?
                                <MapContainer key={refresh} center={[center_lat, center_lng]} zoom={12} scrollWheelZoom={true} style={{height: '100vh'}}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <GeoJSON 
                                        key={refresh} 
                                        data={map_sebaran} 
                                        // onEachFeature={(country, layer) => {
                                        //     _geojson_extract(country, layer)
                                        // }}
                                        // style={_map_geo_style} 
                                    />
                                    {/* <Marker position={[center_lat, center_lng]}>
                                        <Popup>
                                            {data}
                                        </Popup>
                                    </Marker> */}
                                </MapContainer>
                            :
                                <div className="_simpr_home_column_container">
                                    <div className={STORAGE_USER && STORAGE_USER[0].e_account === 'e_simpr_bprb' ? "_simpr_home_column_1 _auth" : "_simpr_home_column_1"}>

                                        <LoadScript
                                            googleMapsApiKey={process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_API_GOOGLE_MAPS_DEVELOPMENT : process.env.REACT_APP_API_GOOGLE_MAPS_PRODUCTION}
                                        >
                                            <GoogleMap
                                                onLoad={handleLoad}
                                                onDragEnd={handleCenter}
                                                center={position}
                                                mapContainerStyle={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0,
                                                    overflow: 'hidden',
                                                }}
                                                zoom={12}
                                                // heading={90}
                                                // tilt={45}
                                                options={{
                                                    fullscreenControl: true,
                                                    panControl: true,
                                                    zoomControl: true,
                                                    mapTypeControl: false,
                                                    mapTypeId: map_type,
                                                    scaleControl: true,
                                                    streetViewControl: true,
                                                    overviewMapControl: true,
                                                    rotateControl: true,
                                                    styles: 
                                                        map_style === 'MAP_STYLE_SILVER' ?
                                                            MAP_STYLE_SILVER
                                                        : map_style === 'MAP_STYLE_RETRO' ?
                                                            MAP_STYLE_RETRO
                                                        : map_style === 'MAP_STYLE_DARK' ?
                                                            MAP_STYLE_DARK
                                                        : map_style === 'MAP_STYLE_NIGHT' ?
                                                            MAP_STYLE_NIGHT
                                                        : map_style === 'MAP_STYLE_AUBERGINE' ?
                                                            MAP_STYLE_AUBERGINE
                                                        : map_style === 'MAP_STYLE_BLACK_WHITE' ?
                                                            MAP_STYLE_BLACK_WHITE
                                                        : map_style === 'MAP_STYLE_PAPER' ?
                                                            MAP_STYLE_PAPER
                                                        : map_style === 'MAP_STYLE_GOLDEN' ?
                                                            MAP_STYLE_GOLDEN
                                                        : map_style === 'MAP_STYLE_NETWORK' ?
                                                            MAP_STYLE_NETWORK
                                                        : map_style === 'MAP_STYLE_BASIC' ?
                                                            []
                                                        : MAP_STYLE_PAPER,
                                                }}
                                            >
                                            </GoogleMap>
                                        </LoadScript>
                                    
                                    </div>
                                    <div className={STORAGE_USER && STORAGE_USER[0].e_account === 'e_simpr_bprb' ? "_simpr_home_column_2 _auth" : "_simpr_home_column_2"}>
                                        <div className="_form" style={{marginTop: 60}}>
                                            <div>
                                                <div className="_row" style={{marginTop: -30}}>
                                                    <div>
                                                        <h1 style={{color: '#118ab2', fontSize: 45}}>e-</h1>
                                                    </div>
                                                    <div className="_column">
                                                        <h1 style={{marginBottom: 30, textAlign: 'center', fontSize: 45}}>
                                                            <span>
                                                                <TextTransition
                                                                    text={ TEXTS[index % TEXTS.length] }
                                                                    springConfig={ presets.wobbly }
                                                                />
                                                            </span>
                                                        </h1>
                                                    </div>
                                                </div>

                                                <div className="_form_box">
                                                    <div>
                                                        <div className="_relative _push_b_l _push_t_m">
                                                            <p className="_overflow_hidden"><ion-icon name="footsteps-outline" style={{fontSize: 18, float: 'left', marginRight: 6}}></ion-icon> Email</p>
                                                            <div className="_bb-input">
                                                                <input 
                                                                    placeholder="" 
                                                                    onChange={e => set_username(e.target.value)}
                                                                    value={username}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p className="_overflow_hidden"><ion-icon name="lock-closed-outline" style={{fontSize: 18, float: 'left', marginRight: 6}}></ion-icon> Password</p>
                                                            <div className="_bb-input">
                                                                <input 
                                                                    type="password"
                                                                    onChange={e => set_password(e.target.value)}
                                                                    value={password} 
                                                                />
                                                            </div>
                                                        </div>
                                                        <p style={{textAlign: 'right'}}> 
                                                            <NavLink 
                                                                to={{
                                                                    pathname: "/simpr/bprb/forget/password",
                                                                }}
                                                                style={{color: '#118ab2'}}
                                                            >
                                                                Lupa Password ?
                                                            </NavLink>
                                                        </p>
                                                        <div className="_bb-btn _push_t_d" onClick={() => _login()}>
                                                            Masuk
                                                        </div> 
                                                    </div>
                                                    
                                                </div>
                                                <div style={{position: 'relative', zIndex: 3}}>
                                                    <p style={{marginTop: 16, marginTop: 16, marginBottom: 52, textAlign: 'center'}}>Belum punya akun? silahkan {` `} 
                                                        <NavLink 
                                                            to={{
                                                                pathname: "/simpr/bprb/register",
                                                            }}
                                                            style={{color: '#118ab2'}}
                                                        >
                                                            Registrasi
                                                        </NavLink>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_simpr_home_column_3">
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/data'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Data} style={{maxWidth: 85}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Data
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/regulasi'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Regulasi} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Regulasi
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/persyaratan'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Persyaratan} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Persyaratan
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/pengaduan'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Pengaduan} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Pengaduan
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <a 
                                                href={"https://www.serdangbedagaikab.go.id"}
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                                target="_blank"
                                            >
                                                <img src={Pelayanan} style={{maxWidth: 75}} />
                                            </a>
                                            <div className="_simpr_home_content_item_title">
                                                Pelayanan
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/tata_ruang'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={TataRuang} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Tata Ruang
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/bprb/panduan'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Panduan} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Panduan
                                            </div>
                                        </div>
                                        <div className="_simpr_home_content_item">
                                            <NavLink 
                                                to='/simpr/home'
                                                className="_simpr_home_content_item_box"
                                                style={{width: 150, height: 140}}
                                            >
                                                <img src={Beranda} style={{maxWidth: 75}} />
                                            </NavLink>
                                            <div className="_simpr_home_content_item_title">
                                                Beranda
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                    </div>
                </div>


            </div>

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;